import { apiFetch, parseApiResponse } from '../../../utils/apiClient';

export const createUser = async (payload) => parseApiResponse(await apiFetch('/api/users/CreateUser', {
  method: 'POST',
  body: JSON.stringify(payload),
}));

export const getUsers = async () => parseApiResponse(await apiFetch('/api/users/GetUsers'));

export const updateUser = async (payload) => parseApiResponse(await apiFetch('/api/users/ModifyUser', {
  method: 'POST',
  body: JSON.stringify(payload),
}));
